// extracted by mini-css-extract-plugin
module.exports = {"sizeInfoMessage":"size-difference-overview_sizeInfoMessage__qCTb1","markdown":"size-difference-overview_markdown__c33Xt"};